const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async stopCampaign({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/stopCampaign", params);
      return data;
    },
    async getWxSchemeUrl({ rootState }, params = {}) {
      const data = await rootState.http("/storeSetting/getWxSchemeUrl", params);
      return data;
    },
    async getFissionQrCodeUrl({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/getFissionQrCodeUrl", params);
      return data;
    },
    async getFissionQrCodeUrlV2({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/getFissionQrCodeUrl/v2", params);
      return data;
    },
    async promoteCampaign({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/promoteCampaign", params);
      return data;
    },
    async queryFissionCampaignDetail({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/queryFissionCampaignDetail", params);
      return data;
    },
    async statisticCampaign({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/statisticCampaign", params);
      return data;
    },
    async batchRepeatManualPush({ rootState }, params = {}) {
      const data = await rootState.http("/maintainRemindRecord/batchRepeatManualPush", params);
      return data;
    },
    async queryFissionCampaign({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/queryFissionCampaign", params);
      return data;
    },
    async updateFission({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/updateFission", params);
      return data;
    },
    async insertFission({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/insertFission", params);
      return data;
    },
    async queryFissionPage({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/queryFissionPage", params);
      return data;
    },
    async getRevisitComment({ rootState }, params = {}) {
      const data = await rootState.http("/revisit/getRevisitComment", params);
      return data;
    },
    async commentRevisit({ rootState }, params = {}) {
      const data = await rootState.http("/revisit/commentRevisit", params);
      return data;
    },
    // 门店员工
    async queryStaffAccountList({ rootState }, params = {}) {
      const data = await rootState.http("/staff/queryStaffAccountList", params);
      return data;
    },
    async queryRevisitCommentList({ rootState }, params = {}) {
      const data = await rootState.http("/revisit/queryRevisitCommentList", params);
      return data;
    },
    async getRevisitRule({ rootState }, params = {}) {
      const data = await rootState.http("/revisit/getRevisitRule", params);
      return data;
    },
    async saveRevisitRule({ rootState }, params = {}) {
      const data = await rootState.http("/revisit/saveRevisitRule", params);
      return data;
    },
    async batchManualPush({ rootState }, params = {}) {
      const data = await rootState.http("/maintainRemindRecord/batchManualPush", params);
      return data;
    },
    async manualPushMaintainRemind({ rootState }, params = {}) {
      const data = await rootState.http("/maintainRemindRecord/manual/push", params);
      return data;
    },

    async queryRemindRecordPage({ rootState }, params = {}) {
      const data = await rootState.http("/maintainRemindRecord/queryRemindRecordPage", params);
      return data;
    },
    async createRemindSetting({ rootState }, params = {}) {
      const data = await rootState.http("/maintainRemindSetting/createRemindSetting", params);
      return data;
    },
    async queryRemindSetting({ rootState }, params = {}) {
      const data = await rootState.http("/maintainRemindSetting/queryRemindSetting", params);
      return data;
    },
    async createPayment({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/addCardTemplate", params);
      return data;
    },
    async createCardTemplate({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/addCardTemplate", params);
      return data;
    },
    async queryCardTemplateList({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/queryList", params);
      return data;
    },
    async updateCardTemplateStatus({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/enable", params);
      return data;
    },

    async updateCardTemplate({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/editCardTemplate", params);
      return data;
    },
    async queryCardTemplateDetail({ rootState }, params = {}) {
      const data = await rootState.http("/card/template/getCardTemplate", params);
      return data;
    },
    async createCard({ rootState }, params = {}) {
      const data = await rootState.http("/card/addCard", params);
      return data;
    },
    async queryCardList({ rootState }, params = {}) {
      const data = await rootState.http("/card/queryList", params);
      return data;
    },
    async queryCardDetail({ rootState }, params = {}) {
      const data = await rootState.http("/card/getCard", params);
      return data;
    },
    async queryCustomerCard({ rootState }, params = {}) {
      const data = await rootState.http("/card/queryCustomerCard", params);
      return data;
    },
    async queryEnableCardListByService({ rootState }, params = {}) {
      const data = await rootState.http("/card/queryEnableList", params);
      return data;
    },
    async queryMiniProgramQrByStore({ rootState }, params = {}) {
      const data = await rootState.http("/storeSetting/findWxQrCode", params);
      return data;
    },
    async updateStoreInfoByWeChat({ rootState }, params = {}) {
      const data = await rootState.http("/store/saveStoreBasicInfo", params);
      return data;
    },
    async queryStoreInfoByWeChat({ rootState }, params = {}) {
      const data = await rootState.http("/store/getStoreBasicInfo", params);
      return data;
    },
    async updateCardStatusRefund({ rootState }, params = {}) {
      const data = await rootState.http("/card/returnCard", params);
      return data;
    },
    async validateAddCard({ rootState }, params = {}) {
      const data = await rootState.http("/card/validateAddCard", params);
      return data;
    },
    async queryCardChangeNoticeChannel({ rootState }, params = {}) {
      const data = await rootState.http("/card/getNotifyMethod", params);
      return data;
    },
    async saveCardChangeNotice({ rootState }, params = {}) {
      const data = await rootState.http("/card/settingNotifyMethod", params);
      return data;
    }
  }
};

export default store;
